import React from "react";
import { AppStoreButtonSettings, ElementViewProps } from "@/shared/types";
import {
  AppleStoreBlackLarge,
  AppleStoreBlackMedium,
  AppleStoreBrandLarge,
  AppleStoreBrandMedium,
  AppleStoreWhiteLarge,
  AppleStoreWhiteMedium,
  GoogleStoreBlackLarge,
  GoogleStoreBlackMedium,
  GoogleStoreBrandLarge,
  GoogleStoreBrandMedium,
  GoogleStoreWhiteLarge,
  GoogleStoreWhiteMedium,
  HuaweiStoreBlackLarge,
  HuaweiStoreBlackMedium,
  HuaweiStoreBrandLarge,
  HuaweiStoreBrandMedium,
  HuaweiStoreWhiteLarge,
  HuaweiStoreWhiteMedium,
  SamsungStoreBlackLarge,
  SamsungStoreBlackMedium,
  SamsungStoreBrandLarge,
  SamsungStoreBrandMedium,
  SamsungStoreWhiteLarge,
  SamsungStoreWhiteMedium,
} from "./illustrations";

export const AppStoreButtons: any = {
  Apple: {
    Black: {
      Large: <AppleStoreBlackLarge />,
      Medium: <AppleStoreBlackMedium />,
    },
    Brand: {
      Large: <AppleStoreBrandLarge />,
      Medium: <AppleStoreBrandMedium />,
    },
    White: {
      Large: <AppleStoreWhiteLarge />,
      Medium: <AppleStoreWhiteMedium />,
    },
  },
  Google: {
    Black: {
      Large: <GoogleStoreBlackLarge />,
      Medium: <GoogleStoreBlackMedium />,
    },
    Brand: {
      Large: <GoogleStoreBrandLarge />,
      Medium: <GoogleStoreBrandMedium />,
    },
    White: {
      Large: <GoogleStoreWhiteLarge />,
      Medium: <GoogleStoreWhiteMedium />,
    },
  },
  Samsung: {
    Black: {
      Large: <SamsungStoreBlackLarge />,
      Medium: <SamsungStoreBlackMedium />,
    },
    Brand: {
      Large: <SamsungStoreBrandLarge />,
      Medium: <SamsungStoreBrandMedium />,
    },
    White: {
      Large: <SamsungStoreWhiteLarge />,
      Medium: <SamsungStoreWhiteMedium />,
    },
  },
  Huawei: {
    Black: {
      Large: <HuaweiStoreBlackLarge />,
      Medium: <HuaweiStoreBlackMedium />,
    },
    Brand: {
      Large: <HuaweiStoreBrandLarge />,
      Medium: <HuaweiStoreBrandMedium />,
    },
    White: {
      Large: <HuaweiStoreWhiteLarge />,
      Medium: <HuaweiStoreWhiteMedium />,
    },
  },
};

export interface AppStoreButtonViewProps extends ElementViewProps {}

const AppStoreButtonView: React.FC<AppStoreButtonViewProps> = ({
  element,
  wuiltContext,
}) => {
  const values = element?.settings as AppStoreButtonSettings;
  const Link = wuiltContext?.base?.Link;
  return (
    <div style={{ width: "fit-content" }}>
      <Link
        href={values?.action?.value}
        target={values?.action?.newTab ? "_blank" : undefined}
      >
        {
          AppStoreButtons?.[values?.action?.type!]?.[values?.design?.style!][
            values?.design?.size!
          ]
        }
      </Link>
    </div>
  );
};

export { AppStoreButtonView };
